export default __webpack_public_path__ + "images/sz-d62f5eab640be40355e8fdca853ed0a4.svg";